export default __webpack_public_path__ + "static/media/CameraIcon.5ff227c8.svg";